import React, { FC, useContext, useMemo } from 'react';
import { SelectProps } from 'formik-antd/src/select/index';
import { Select } from 'formik-antd';
import { HigoDictionaryContext } from 'core/HigoDictionaryProvider';

export const GenderSelect: FC<SelectProps> = (props) => {
  //todo: Add types, and extract sort + map fn
  const { GENDER }: any = useContext(HigoDictionaryContext);

  const options = useMemo(
    () =>
      Object.values(GENDER)
        .sort((a: any, b: any) => b.priority - a.priority)
        .map((x: any) => (
          <Select.Option key={x.code} value={x.code}>
            {x.value}
          </Select.Option>
        )),
    [GENDER]
  );

  return <Select {...props}>{options}</Select>;
};
